$j(document).ready(function () {

     /* Promo Lightbox Implementation */

    $j(window).load(function() {
        $j(".trigger_popup_bmsm").click(function() {
            $j('.hover_bkgr_bmsm').first().show();
        });
        $j('.hover_bkgr_bmsm').click(function() {
            $j('.hover_bkgr_bmsm').hide();
        });
        $j('.popupCloseButton').click(function() {
            $j('.hover_bkgr_bmsm').hide();
        });
    });

    /* ---------------------------------------------------- OUT OF STOCK (TEST IOS) --------------------------------------------- */
    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };
    if( isMobile.iOS() )
    {
        $j("#product-options-wrapper select").each(function(){
            $j(this).prepend("<optgroup>");
            $j(this).append("<optgroup>");
        });
    }


    /* ---------------------------------------------------- SCROLL --------------------------------------------- */

    /* - SCROLL Animate Ancre - */
    $j('.cms a[href^="#"]').click(function(){
        var the_id = $j(this).attr("href");
        $j('html, body').animate({ scrollTop:($j(the_id).offset().top)-50 }, 'slow');
        return false;
    });

    /* - SCROLL Top Add To Cart - */
    $j('#product-addtocart-button').click(function(){
        $j("html, body").animate({ scrollTop: 0 }, 400);
        return false;
    });

    $j('#onestepcheckout-login-link').click(function(){
        $j("html, body").animate({ scrollTop: 0 }, 400);
        return false;
    });
    $j('#pop-bed').click(function(){
        $j("html, body").animate({ scrollTop: 0 }, 400);
        return false;
    });
    $j('a[rel^="prettyPhoto"]').click(function(){

        $j("html, body").animate({ scrollTop: 0 }, 400);
        return false;
    });

    /* - SCROLL Ancre FadeIn / FadeOut - */
    $j(function(){
        var shrinkHeader = 250;
        $j(window).scroll(function() {
            var scroll = getCurrentScroll();
            if ( scroll >= shrinkHeader ) {
                $j('#scrolltop').fadeIn();
            }
            else {
                $j('#scrolltop').fadeOut();
            }
        });
        function getCurrentScroll() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }
    });

    // smooth scroll
    $j('.scrollto').click( function() { // Au clic sur un élément
        var page = $j(this).attr('href'); // id cible
        var speed = 750; // Durée de l'animation (en ms)
        $j('html, body').animate( { scrollTop: $j(page).offset().top }, speed ); // Go
        return false;
    });

    /* --------------------------------------------------- Out of stock IOS ---------------------------------------------- */
    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };
    if( isMobile.iOS() )
    {
        $j("#product-options-wrapper select").each(function(){
            $j(this).prepend("<optgroup>");
            $j(this).append("<optgroup>");
        });
    }

    /* --------------------------------------------------- OVERLAY ------------------------------------------- */

    $j('#pop-overlay').click(function(event){
        $j("#ajaxnotice").hide();
        $j("#pop-overlay").fadeOut();
        $j(".dialog").hide();
        $j(".messages").hide();
        $j("#dialog_system").hide();
        $j("#promo-pop").fadeOut();
        $j(".jason_wu_overlay").fadeOut();
    });

    $j(".cancel-sub").click(function(){
        $j("#pop-overlay").fadeOut();
        $j(".dialog").hide();
    });

    $j('.jason_wu').click(function(event){
        $j("#pop-overlay").fadeIn();
        $j(".jason_wu_overlay").fadeIn();
    });

    $j(".close-bed-disclaimer").click(function(){
        $j("#pop-overlay").fadeOut();
        $j(".dialog").hide();
    });
    /* ------ POP UP MESSAGE VALIDATION ------ */

    if( $j("#admin_messages").text() != "" ){
        $j("#pop-overlay").fadeIn('fast');
        $j(".messages").fadeIn('fast');
        $j("input").blur();
    }

    if( $j(".messages").text() != "" ){
        $j("#pop-overlay").fadeIn('fast');
        $j(".messages").prepend("<div class='dialog_close'></div>");
        $j("input").blur();
        if ($j(".main .messages li").hasClass('error-msg')){
            $j(".messages").addClass('error-msg');
        }
        $j(".messages").fadeIn('fast');
    }

    $j(".dialog_close").click(function(event){
        $j(".messages").hide();
        $j("#pop-overlay").hide();
        $j(".jason_wu_overlay").fadeOut();
    });
    $j(".cancel").click(function(event){
        $j(".messages").hide();
        $j(".dialog").hide();
        $j("#pop-overlay").hide();
        $j(".jason_wu_overlay").fadeOut();
    });

    /* --------------------------------------------------- CHECKOUT ------------------------------------------ */

    // OneStepcheckout -- Error shipping
    $j("#onestepcheckout-place-order").click(function(event){
        if( $j('input[name=shipping_method]').is(':checked')){
            $j(".onestepcheckout-shipping-method-block").first().removeClass("shipping-empty-error");
        } else{
            $j(".onestepcheckout-shipping-method-block").first().addClass("shipping-empty-error");
        }});

    // OneStepcheckout -- Coupon
    $j(".onestepcheckout-coupons label").click(function(event){
        $j(".coupon-container").slideToggle(150);
    });

// JS PRODUCT MENU

    $j('#overlay_related').click(function(event){
        $j("#overlay_related").fadeOut(200);
    });
    $j('.dialog_close').click(function(event){
        $j("#overlay_related").fadeOut(200);
    });




});

function popRelated(src){
    $j(".popImgRel").attr("src",src);
    $j("#overlay_related").fadeIn(200);
}

$j(document).ready(function () {
    // Manage related products
    if($j('#block-related')){

        // Observe related product checkboxes change
        $$('.related-checkbox').each(function(checkbox){
            Event.observe(checkbox, 'click', function(){
                var relatedProductsFieldValue = [];
                $$('.related-checkbox:checked').each(function(e){relatedProductsFieldValue.push(e.value);});
                if($('related-products-field')){
                    $('related-products-field').value = relatedProductsFieldValue.join(',');
                    $('related-products-qty').value = $j('input#qty').val();
                }
            });
        });

        // Observe add to cart buttons
        $$('#product-addtocart-button').each(function(elem){
            Event.observe(elem, 'click', function(e){});
        });

        // Set default parent product (init state)
        var originalProductId = null;
        $$("#block-related li.item").each(function(item){
            if($j(item).attr('data-related-default')){
                originalProductId = $j(item).attr('data-related-parent-id');
            }
        });

        // Observer selects (product attributes)
        if($j('.super-attribute-select')){
            var elemLast = $j('.super-attribute-select').last();

            $j('.super-attribute-select').change(function(e){
                e.stopPropagation();
                $('related-products-field').value = ''; // Reset related input when changing parent product
                var selectValue = this.value;

                if(selectValue == "" || selectValue != elemLast.val()){
                    refreshRelatedProduct(originalProductId);
                    return;
                }else{
                    $(this.config.options).each(function(option){
                        if(option.id == selectValue && option.allowedProducts[0]){
                            refreshRelatedProduct(option.allowedProducts[0]);
                            return;

                        }
                    });
                }
            });
        }
    }
});

function refreshRelatedProduct(childProductId){
    $j('.related-checkbox:checked').trigger("click")
    var checkedBoxes = [];

    $$('.related-checkbox').each(function(elem){
        checkedBoxes.push(elem.checked);
    });
    // Display/Don't display li.item elements depending on childProductId selected
    $$("#block-related li.item").each(function(item){
        if(childProductId == $j(item).attr('data-related-parent-id')){
            $j(item).removeClass('hidden');
            // Force show block related
            $j('#block-related').show();

            // Check checked checkboxes
            relatedProductsFieldValue = [];
            $j(item).find('input.related-checkbox').each(function(i, chk){
                if(chk.checked){
                    relatedProductsFieldValue.push(chk.value);
                }
            });
            $('related-products-field').value = relatedProductsFieldValue.join(',');
            $('related-products-qty').value = $j('input#qty').val();
        }else{

            $j(item).addClass('hidden');
        }
    });
}

$j(document).ready(function(){
    if($j('.wapper-slider').length > 0){
        $j('.wapper-slider').bxSlider({
            auto: true,
            autoHover: true,
            pager: false,
            mode: 'fade',
            slideWidth: 716,
            infiniteLoop: true,
            responsive: true,
            touchEnabled: true,
            controls: true,
            nextText: '',
            prevText: ''
        });
    }

});


/* Scripts for Redesign from US */

var $j = jQuery.noConflict();
/* Everyththing under this line is a script from LUX-US (with minor modifications)*/

(function(n) { n.viewportSize = {}, n.viewportSize.getHeight = function() { return t("Height"); }, n.viewportSize.getWidth = function() { return t("Width"); }; var t = function(t) { var f, o = t.toLowerCase(),
            e = n.document,
            i = e.documentElement,
            r, u; return n["inner" + t] === undefined ? f = i["client" + t] : n["inner" + t] != i["client" + t] ? (r = e.createElement("body"), r.id = "vpw-test-b", r.style.cssText = "overflow:scroll", u = e.createElement("div"), u.id = "vpw-test-d", u.style.cssText = "position:absolute;top:-1000px", u.innerHTML = "<style>@media(" + o + ":" + i["client" + t] + "px){body#vpw-test-b div#vpw-test-d{" + o + ":7px!important}}<\/style>", r.appendChild(u), i.insertBefore(r, e.head), f = u["offset" + t] == 7 ? i["client" + t] : n["inner" + t], i.removeChild(r)) : f = n["inner" + t], f } })(this);
$j(document).ready(function() {
    var mobile = false;
    var tablet = false;
    var desktop = false;
    function checkWidth() {
        var viewportWidth = $j(window).width();
        if (viewportWidth <= 660) {
            if (!mobile) {
                $j('body').addClass('mobile').removeClass('desktop tablet');
                $j('body.catalog-product-view ul.slides li a').contents().unwrap(); 
            }
            mobile = true;
            desktop = false;
            tablet = false;
        } else if (viewportWidth >= 661 && viewportWidth <= 960) {
            if (!tablet) {
                $j('body').removeClass('mobile dekstop').addClass('tablet');
            }
            mobile = false;
            desktop = false;
            tablet = true;
        } else {
            if (!desktop) {
                $j('body').removeClass('mobile tablet').addClass('desktop');
            }
            mobile = false;
            desktop = true;
            tablet = false;
        }
    }
    checkWidth();
    $j(window).resize(checkWidth);
    
    /* Menus*/

    function toggleSites() {
        $j('.global-sites li ul').slideToggle('fast');
        $j('#btn_global').toggleClass('sites-active sites-inactive');
    }

    function toggleTopNav() {
        $j("#btn-main-nav").toggleClass('activated inactive');
        $j('ul.top-nav').slideToggle('fast');
        $j('body').toggleClass('menu-open');
    }
    $j('html').click(function() {
        if ($j(".global-sites li ul").not(".mobile .global-sites li ul").is(":visible")) {
            $j('.global-sites > li > p').toggleClass('sites-inactive sites-active').next("ul").slideToggle('fast');
        }
    });
    $j('html').click(function() {
        if ($j("ul.top-nav").not(".desktop ul.top-nav").is(":visible")) {
            $j("ul.top-nav").not('.mobile ul.top-nav').slideUp('fast');
            $j("#btn-main-nav").not('.mobile #btn-main-nav').toggleClass('inactive activated');
            $j('body').not('body.mobile').toggleClass('menu-open');
        }
    });
    $j("#btn_global").click(function() {
        if ($j("ul.top-nav").not('body.desktop ul.top-nav').is(":visible")) {
            toggleTopNav();

        }
        toggleSites();
    });
    $j('.global-sites > li > p, #btn-main-nav').click(function(event) {
        event.stopPropagation();
    });

    function closeLeftNav() {
        $j("#btn-left-nav").toggleClass('leftnav-active leftnav-inactive ').next().removeClass('nav-opened');
    }
    $j("#btn-main-nav").click(function() {
        if ($j(".global-sites li ul").is(":visible")) {
            toggleSites();
        }
        toggleTopNav();
    });

    $j("#btn-left-nav").click(function() {
        if ($j(this).hasClass("leftnav-inactive")) {
            $j("div.left-nav").animate({
                left: '0px'
            }, 200, 'linear');
            $j(this).toggleClass('leftnav-inactive leftnav-active').next().addClass('nav-opened');
        } else {
            $j("div.left-nav").animate({
                left: '-350px'
            }, 200, 'linear');
            closeLeftNav();
        }
        return false;
    });      

    //Calculate Footer height for parallax effect

    function checkHeight() {
        var footerHeight = $j('div.footer-wrap-bottom').height();
        $j('div.footer-wrap-top').not('body.ops-payment-paypage div.footer-wrap-bottom').css('margin-bottom', footerHeight + 'px');
    }
    checkHeight();
    $j(window).resize(checkHeight);
    //Product Page Item description collapse and tabs

    /* Product Page Tabs */
    $j('#tabs > div').hide();
    $j('#tabs > div:first').show();
    $j('#tabs > ul.tab-links li:first').addClass('active');
    $j('#tabs > ul.tab-links li a').click(function() {
        $j('#tabs > ul.tab-links li').attr('class', '');
        $j(this).parent().attr('class', 'active');
        var currentTab = $j(this).attr('href');
        $j('#tabs > div').hide();
        $j(currentTab).show();
        return false;
    });

    /*Flexslider */
    $j(window).load(function() {
        $j('.item-image').flexslider({
            animation: "slide",
            animationLoop: false,
            useCSS: false
            
        });
    });


    /* Promo Headers - */
    (function($j) {
        $j.fn.flowtype = function(options) {
            var settings = $j.extend({
                    maximum: 9999,
                    minimum: 1,
                    maxFont: 9999,
                    minFont: 1,
                    fontRatio: 35
                }, options),
                changes = function(el) {
                    var $jel = $j(el),
                        elw = $jel.width(),
                        width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
                        fontBase = width / settings.fontRatio,
                        fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
                    $jel.css('font-size', fontSize + 'px');
                };

            return this.each(function() {
                var that = this;
                $j(window).resize(function() {
                    changes(that);
                });
                changes(this);
            });
        };
    }(jQuery));

    $j('#hdr-banner p, .sweeps_banner').flowtype({
        minimum: 420,
        maximum: 1200,
        minFont: 16,
        maxFont   : 45,
        fontRatio: 35
    });
    $j('.promo-wrapper .promo-inner').flowtype({
        minimum: 420,
        maximum: 1200,
        minFont: 12,
        //maxFont   : 45,
        fontRatio: 40
    });
    $j('.hero-wrap .promo-wrapper .promo-inner').flowtype({
        minimum: 660,
        maximum: 1600,
        minFont: 16,
        maxFont   : 40,
        fontRatio: 40
    });
    /*Detections*/
    var root = document.getElementsByTagName('html')[0];
    if (!document.createElement('svg').getAttributeNS) {
        root.setAttribute("class", "no-svg");
        return;
    }
    /* IE 10 Detection due to checkbox issues*/
    if (Function('/*@cc_on return document.documentMode===10@*/')()) {
        document.documentElement.className += ' ie10';
    }
    //Add a class to the last letter on left nav so arrow travels with it

    /* Topnav Hover */
                $j('.top-nav').hover(
                function() {
                    $j('.header .gradient').css({
                        'min-height': '700px'
                    });
                },
                function() {
                    $j('.header .gradient').css({
                        'min-height': '195px'
                    });
                });
             $j('.top-nav li').hover(
                function() {
                    $j(this).addClass('hover');
                },
                function() {
                    $j(this).removeClass('hover');
                });           




   
            /*Hover Intent*/
            var $dropdowns = $j('.shop-cart');
            $dropdowns
                .on('mouseover', function() 
                    {
                        var $this = $j(this);
                        if ($this.prop('hoverTimeout')) {
                            $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
                        }
                        $this.prop('hoverIntent', setTimeout(function() {
                            $this.addClass('hover');
                        }, 200));
                    })
                .on('mouseleave', function() {
                    var $this = $j(this);
                    if ($this.prop('hoverIntent')) {
                        $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
                    }
                    $this.prop('hoverTimeout', setTimeout(function() {
                        $this.removeClass('hover');
                    }, 400));
                });
                //Delay GIF Loading
                setTimeout(function(){
                    $j('body.pghome div.cinema-graph-gif').css('background', 'url("/skin/frontend/default/luxeu/images/banners/luxury-collection-Vana-Belle-Koh-Samui-thailand-beach.gif") no-repeat center 50px/contain');
                }, 2000);
    /* Product Item Odd/Even */
    $j('div.item').filter(":odd").removeClass('even').addClass('odd');

    /* Tablet/Mobile Sizing Chart */
    $j(document).on('click', '.tablet .size_chart_container em.one, .mobile .size_chart_container em.one' , function () {
        $j('.tablet .size_chart_container em.one, .mobile .size_chart_container em.one').siblings().removeClass('show');
        $j(this).siblings().addClass('show');
    });
});

/**
 * Recaptcha incription aux newsletters et formulraire de contact
 *
 */
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email.match(re);
}

// Remove Currency Symbol for EUR (need to add GBP, CHF, etc. later)
function removeCurrencySymbol (val) {
    var reg = /€|£/g;
    return val.replace(reg, '');
}

/* Misc Global Functions */
function formatPrice (val, lang) {
    console.log('formatPrice', val, lang);
    var price = val;
    if (val) {
      if (lang === 'en' || lang === '_en') {
        price = price.replace(/\s|,/g, '');
      } else if (lang === 'fr' || lang === '_fr') {
        price = price.replace(/,/g, '.');
        price = price.replace(/\s/g, '');
      } else if (lang === 'de' || lang === 'es' || lang === '_de' || lang === '_es') {
        price = price.replace(/\s|\./g, '');
        price = price.replace(/,/g, '.');
      }
      price = removeCurrencySymbol(price);
      console.log('formatPrice Price:', price);
    }
  
    return price;
}